import { Toaster } from 'sonner';

interface SonnerProps {
  position?: 'top-left' | 'top-center' | 'top-right' | 'bottom-left' | 'bottom-center' | 'bottom-right';
  theme?: 'light' | 'dark' | 'system';
  richColors?: boolean;
  closeButton?: boolean;
  expand?: boolean;
}

export const Sonner = ({
  position = 'bottom-right',
  theme = 'system',
  richColors = true,
  closeButton = true,
  expand = false,
}: SonnerProps) => {
  return (
    <Toaster
      position={position}
      theme={theme}
      richColors={richColors}
      closeButton={closeButton}
      expand={expand}
      toastOptions={{
        classNames: {
          toast: 'group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg',
          title: 'group-[.toast]:text-foreground',
          description: 'group-[.toast]:text-muted-foreground',
          actionButton: 'group-[.toast]:bg-primary group-[.toast]:text-primary-foreground',
          cancelButton: 'group-[.toast]:bg-muted group-[.toast]:text-muted-foreground',
        },
      }}
    />
  );
};

export {
  Toaster,
} from 'sonner';